<ng-container *ngFor="let flight of flights; let i = index">
  <div
    class="flight-box"
    (click)="clickFlight(i)"
    (mouseenter)="over(i)"
    (mouseleave)="leave(i)"
    [class.rescheduled]="flight.status === 'rescheduled'"
    [class.hover-flight]="canSelect && flight.isHovered && !selectedHide"
    [class.checked-flight]="canSelect && flight.isChecked && !selectedHide"
  >
    <app-flight-content
      [flight]="flight"
      [associatedFlight]="associatedFlight"
      [isAirline]="isAirline"
      [isInvoluntary]="isInvoluntary"
      [passengerCount]="passengerCount"
      [isHeader]="isHeader"
      [index]="i"
      [showBaggage]="showBaggage"
      (changeClass)="changeClass.emit($event)"
    ></app-flight-content>
  </div>

  <app-wait-time-banner
    *ngIf="flight.waitingTime"
    message="{{
      'itinerary-info.flight.waiting' | translate : { time: (flight.waitingTime | TimeOfFlight) }
    }}"
  >
  </app-wait-time-banner>
</ng-container>
